export const fileAttachmentQueryKeys = {
  base: ['fileAttachment'],
  fileAttachments: (itemID: string | undefined | null) => [
    ...fileAttachmentQueryKeys.base,
    'fileAttachments',
    itemID,
  ],
};
